if (!customElements.get('product-impermeabilization')) {
  customElements.define(
    'product-impermeabilization',
    class ProductImpermeabilization extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      constructor() {
        super();
        this.checkbox = this.querySelector('.product-impermeabilization__checkbox');
        this.message = this.querySelector('[data-impermeabilization-message]');
        this.areaNode = this.querySelector('[data-impermeabilization-area]');
        this.totalNode = this.querySelector('[data-impermeabilization-total]');
        this.productVariants = JSON.parse(
          this.querySelector('[data-product-variants]')?.textContent || '[]'
        );
        this.serviceVariants = JSON.parse(
          this.querySelector('[data-service-variants]')?.textContent || '[]'
        );
      }

      connectedCallback() {
        this.boundRefresh = this.refresh.bind(this);
        this.bindFormElements();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const sectionId = this.closest('product-info')?.dataset.section;
          if (event?.data?.sectionId !== sectionId) return;

          this.bindFormElements();
          this.refresh();
        });

        this.refresh();
      }

      disconnectedCallback() {
        this.unbindFormElements();
        this.variantChangeUnsubscriber?.();
      }

      bindFormElements() {
        this.unbindFormElements();

        this.productForm = this.closest('product-form');
        this.form = this.productForm?.querySelector('form');
        this.variantInput = this.form?.querySelector('[name="id"]');
        this.quantityInput = this.form?.querySelector('[name="quantity"]');

        this.checkbox?.addEventListener('change', this.boundRefresh);
        this.variantInput?.addEventListener('change', this.boundRefresh);
        this.quantityInput?.addEventListener('input', this.boundRefresh);
        this.quantityInput?.addEventListener('change', this.boundRefresh);
      }

      unbindFormElements() {
        this.checkbox?.removeEventListener('change', this.boundRefresh);
        this.variantInput?.removeEventListener('change', this.boundRefresh);
        this.quantityInput?.removeEventListener('input', this.boundRefresh);
        this.quantityInput?.removeEventListener('change', this.boundRefresh);
      }

      parseArea(variantTitle) {
        if (!variantTitle) return 0;
        const match = variantTitle.match(/(\d+(?:[.,]\d+)?)\s*m?\s*x\s*(\d+(?:[.,]\d+)?)/i);
        if (!match) return 0;
        const width = Number(match[1].replace(',', '.'));
        const height = Number(match[2].replace(',', '.'));
        return width * height;
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: 'CLP',
          maximumFractionDigits: 0
        }).format((cents || 0) / 100);
      }

      getCurrentVariant() {
        const variantId = Number(this.variantInput?.value || 0);
        return this.productVariants.find(variant => Number(variant.id) === variantId);
      }

      getCurrentQuantity() {
        const quantity = Number.parseInt(this.quantityInput?.value || '1', 10);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      getSelectedService() {
        const currentVariant = this.getCurrentVariant();
        const serviceVariant = this.serviceVariants.find(variant => variant.available) || this.serviceVariants[0];
        const area = this.parseArea(currentVariant?.title);
        const productQuantity = this.getCurrentQuantity();
        const quantity = Math.max(1, Math.ceil(area * productQuantity));

        return {
          selected: Boolean(this.checkbox?.checked && serviceVariant),
          variantId: serviceVariant ? Number(serviceVariant.id) : null,
          quantity,
          productQuantity,
          area,
          currentVariantTitle: currentVariant?.title || '',
          serviceVariantPrice: serviceVariant ? Number(serviceVariant.price) : 0,
          serviceProductHandle: this.dataset.serviceProductHandle,
          productTitle: this.dataset.productTitle
        };
      }

      refresh() {
        const serviceConfig = this.getSelectedService() || {};
        const currentVariant = this.getCurrentVariant();
        const area = this.parseArea(currentVariant?.title);
        const quantity = this.getCurrentQuantity();
        const roundedAreaQuantity = Math.max(1, Math.ceil(area * quantity));
        const matchingServiceVariant = this.serviceVariants.find(variant => variant.available) || this.serviceVariants[0];

        if (this.areaNode) {
          this.areaNode.textContent = `${(area * quantity).toFixed(2).replace('.', ',')} m²`;
        }

        if (this.totalNode) {
          const total = matchingServiceVariant
            ? Number(matchingServiceVariant.price) * roundedAreaQuantity
            : 0;
          this.totalNode.textContent = this.formatMoney(total);
        }

        if (this.checkbox) {
          this.checkbox.disabled = !matchingServiceVariant;
          if (!matchingServiceVariant) this.checkbox.checked = false;
        }

        if (this.message) {
          this.message.classList.toggle('hidden', Boolean(matchingServiceVariant));
          this.message.textContent = this.dataset.defaultUnavailableText || '';
        }
      }
    }
  );
}
